<template>
  <b-form class="1w-100 form" @submit="onSubmit">
    <b-row cols="1">
      <b-col class="col-md-4">
        <b-form-group label="Tipo de arquivo:" label-for="idMerchantFileType">
          <a-select v-model="form.idMerchantFileType">
            <a-select-option value="0"> Selecione </a-select-option>
            <a-select-option
              :value="item.id"
              v-for="(item, index) in merchantfiletypes"
              :key="`merchantfiles-${index}`"
            >
              {{ item.description }}
            </a-select-option>
          </a-select>
        </b-form-group>
      </b-col>

      <b-col>
        <b-form-group label="Arquivos" label-for="document">
          <Upload
            ref="upload"
            @files="handleChange"
            @add-file="onAddFile"
            @remove-file="onRemoveFile"
            :multiple="false"
          />
        </b-form-group>
      </b-col>
    </b-row>

    <hr />

    <div class="row">
      <div class="col-xl">
        <b-btn
          type="submit"
          class="col-md-2"
          variant="outline-primary"
          :disabled="loading"
          >Salvar
          <b-spinner
            small
            variant="primary"
            label="Spinning"
            v-show="loading"
          ></b-spinner>
        </b-btn>
      </div>
    </div>
  </b-form>
</template>

<script>
import { get as _get } from "lodash";
import { MerchantFilesResource } from "@/resources/MerchantFiles.resource.js";
import { MaskUtils } from "@/utils/MaskUtils.js";

import Upload from "@/components/Upload.vue";

export default {
  components: {
    Upload,
  },
  props: {
    idMerchant: {
      type: Number,
      default: function () {
        return 0;
      },
    },
  },

  data() {
    return {
      loading: false,
      merchantfiletypes: [],
      form: {
        name: "",
        idMerchantFileType: "",
        imgData: "",
      },
      merchantfiles: [],
    };
  },
  computed: {
    sysAdminUser() {
      try {
        return (
          this.$store.getters.user.role
            .split(",")
            .filter((role) => role === "SystemAdmin").length > 0
        );
      } catch (e) {
        return false;
      }
    },
  },
  methods: {
    getMerchantFileType() {
      MerchantFilesResource.getFileTypeKeyValue()
        .then((result) => {
          try {
            this.loading = false;
            this.merchantfiletypes = result.data.payload;
          } catch (e) {
            throw {
              response: {
                data: {
                  failureReason: "Deu ruim na chamada...",
                },
              },
            };
          }
        })
        .catch((e) => {
          this.loading = false;
        });
    },

    getBase64(img, callback) {
      const reader = new FileReader();
      reader.addEventListener("load", () => callback(reader.result));
      reader.readAsDataURL(img);
    },

    handleChange() {
      const v = this;

      try {
        const file = v.$refs.upload.$refs.pond.getFile().file;
        v.form.name = file.name;
        v.getBase64(file, (imageUrl) => {
          v.form.imgData = imageUrl;
        });
      } catch (e) {
        // Surpress
      }
    },

    onRemoveFile(error, fileData) {
      this.form.name = null;
      this.form.imgData = null;
    },
    onAddFile(error, fileData) {
      const v = this;
      const file = fileData.file;
      try {
        v.form.name = file.name;
        v.getBase64(file, (imageUrl) => {
          v.form.imgData = imageUrl;
        });
      } catch (e) {
        // Surpress
      }
    },

    async onSubmit(e) {
      e.preventDefault();

      const data = {
        ...this.form,
        idMerchant: parseInt(this.$route.params.id),
      };

      if (data.idMerchant > 1 && this.form.imgData != null) {
        this.loading = true;
        const vm = this;
        MerchantFilesResource.registerMerchantFile(data)
          .then((result) => {
            try {
              vm.loading = false;
              this.$notification["success"]({
                message: "Registro inserido",
                description: "",
              });
              this.loading = false;
              this.$emit("update", true);
            } catch (e) {
              throw {
                response: {
                  data: {
                    failureReason: "Deu ruim na chamada...",
                  },
                },
              };
            }
          })
          .catch((e) => {
            this.loading = false;
          });
      }
    },
  },
  created() {
    this.getMerchantFileType();
  },
};
</script>

<style lang="css">
.width-150 {
  width: 150px;
}
.form .is-invalid,
.form .is-valid {
  padding-right: 0;
}
</style>
